<h2 style="margin-top: 30px; margin-bottom: 15px; margin-left: 10px">Tilinpäätöksen rekisteröinti</h2>

@if (tilikaudenLoppumisestaOnYli8KkObservable | async) {
  <div>
    Tilikauden vaihteesta on yli 8kk, eikä rekisteröintiä voi enää tehdä Lemonatorista rajapinnan kautta. Rekisteröinti on tehtävä käsin:
    <a href="https://www.prh.fi/fi/yrityksetjayhteisot/tilinpaatokset/yrityksen_tilinpaatos_myohassa.html" target="_BLANK"> https://www.prh.fi/fi/yrityksetjayhteisot/tilinpaatokset/yrityksen_tilinpaatos_myohassa.html </a>.
  </div>
}

<form>
  <div style="margin: 20px">
    @if (tilinpaatosAllekirjoitettamattaObservable | async) {
      <mat-checkbox [formField]="lomake.tilinpaatosPerinteisesti">Tilinpäätös allekirjoitetaan perinteisesti</mat-checkbox>
    } @else {
      @if (tilinpaatosAllekirjoitettuJarjestelmanUlkopuolellaObservable | async) {
        <div>
          @for (prev of previoslySentThirdPartyTilinpaatokset | async; track prev) {
            <div>
              <app-button (click)="downloadTilinpaatosPdfWithVersionKey(prev.avain)" actionId="Lataa allekirjoitettu tilinpäätös koneelle (rekisteröinti)" styles="padding: 0 2px; vertical-align: middle;">
                <div style="display: flex; flex-direction: row; align-items: center; padding: 0 5px">
                  <div class="pdf-btn">
                    <div>PDF</div>
                    <mat-icon style="font-size: 14px; height: 15px; line-height: 15px">save_alt</mat-icon>
                  </div>
                  <div style="padding-left: 10px">Allekirjoitettu tilinpäätös</div>
                </div>
              </app-button>
              (Ladannut {{ prev.kirjanpitaja }} {{ prev.ladattu }})
            </div>
          }
        </div>
      } @else {
        <div>
          <app-button (click)="downloadTilinpaatosPdfWithVersionKey()" actionId="Lataa allekirjoitettu tilinpäätös koneelle (rekisteröinti)" styles="padding: 0 2px;">
            <div style="display: flex; flex-direction: row; align-items: center; padding: 0 5px">
              <div class="pdf-btn">
                <div>PDF</div>
                <mat-icon style="font-size: 14px; height: 15px; line-height: 15px">save_alt</mat-icon>
              </div>
              <div style="padding-left: 10px">Allekirjoitettu tilinpäätös</div>
            </div>
          </app-button>
        </div>
        @if (showHallituksenPoytakirjaDownloadBtnObservable | async) {
          <div>
            <app-button (click)="downloadHallituksenPoytakirjaPdf()" actionId="Lataa hallituksen pöytäkirja koneelle (rekisteröinti) " styles="padding: 0 2px;">
              <div style="display: flex; flex-direction: row; align-items: center; padding: 0 5px">
                <div class="pdf-btn">
                  <div>PDF</div>
                  <mat-icon style="font-size: 14px; height: 15px; line-height: 15px">save_alt</mat-icon>
                </div>
                <div style="padding-left: 10px">Hallituksen pöytäkirja</div>
              </div>
            </app-button>
          </div>
        }
      }
    }
  </div>

  @if (lomake.tilinpaatosPerinteisesti().value()) {
    <div style="margin: 20px 40px">
      @if (tpUploadError()) {
        <div style="margin: 20px 0" class="error-text">{{ tpUploadError() }}</div>
      }
      @if (liitetiedotLuomattaObservable | async) {
        <div style="margin: 20px 0" class="error-text">Liitetiedot ovat luomatta. Täytä liitetiedot ennen lataamista.</div>
      }
      <app-secondary-button (click)="lisaaTilinpaatos()" [disabled]="liitetiedotLuomattaObservable | async" actionId="Valitse tiedosto: Muualla allekirjoitettu tilinpäätös (rekisteröinti)"> + Lataa muualla allekirjoitettu tilinpäätös </app-secondary-button>
    </div>
  }

  <div style="margin: 20px">
    @if (poytakirjaAllekirjoitettamattaObservable | async) {
      <mat-checkbox [formField]="lomake.poytakirjaPerinteisesti">Yhtiökokouksen pöytäkirja allekirjoitetaan perinteisesti</mat-checkbox>
    } @else {
      <div style="margin: 20px 0">
        <div>
          <app-button (click)="downloadYhtiokokousPdf()" actionId="Lataa yhtiökokouksen pöytäkirja koneelle (rekisteröinti)" styles="padding: 0 2px;">
            <div style="display: flex; flex-direction: row; align-items: center; padding: 0 5px">
              <div class="pdf-btn">
                <div>PDF</div>
                <mat-icon style="font-size: 14px; height: 15px; line-height: 15px">save_alt</mat-icon>
              </div>
              <div style="padding-left: 10px">Yhtiökokouksen pöytäkirja</div>
            </div>
          </app-button>
        </div>
        <div style="margin-top: 20px">
          <app-button (click)="downloadTilinpaatosilmoitusPdf()" actionId="Lataa tilinpäätös ilmoitus koneelle (rekisteröinti)" styles="padding: 0 2px;">
            <div style="display: flex; flex-direction: row; align-items: center; padding: 0 5px">
              <div class="pdf-btn">
                <div>PDF</div>
                <mat-icon style="font-size: 14px; height: 15px; line-height: 15px">save_alt</mat-icon>
              </div>
              <div style="padding-left: 10px">Tilinpäätösilmoitus PRH:lle</div>
            </div>
          </app-button>
        </div>
      </div>
    }
  </div>

  @if (lomake.poytakirjaPerinteisesti().value()) {
    <div style="margin: 20px 40px">
      @if (pkUploadError()) {
        <div style="margin: 20px 0" class="error-text">{{ pkUploadError() }}</div>
      }
      @if (liitetiedotLuomattaObservable | async) {
        <div style="margin: 20px 0" class="error-text">Liitetiedot ovat luomatta. Täytä liitetiedot ennen lataamista.</div>
      }
      @if (tilinpaatosAllekirjoitettamattaObservable | async) {
        <div style="margin: 20px 0" class="error-text">Tilinpäätöstä ei ole vielä allekirjoitettu tai ladattu.</div>
      }
      @if ((tilintarkastetaanObservable | async) && (tilintarkastusKertomusLataamatta | async)) {
        <div style="margin: 20px 0" class="error-text">Tilintarkastuskertomusta ei ole vielä ladattu.</div>
      }
      <app-secondary-button (click)="lisaaPoytakirja()" [disabled]="(liitetiedotLuomattaObservable | async) || (tilinpaatosAllekirjoitettamattaObservable | async) || ((tilintarkastetaanObservable | async) && (tilintarkastusKertomusLataamatta | async))" actionId="Valitse tiedosto: Muualla allekirjoitettu yhtiökokouksen pöytäkirja">
        + Lataa muualla allekirjoitettu yhtiökokouksen pöytäkirja
      </app-secondary-button>
      @if (poytakirjaUploadedObservable | async) {
        <span style="margin: 5px; font-size: 12px">PDF ladattu</span>
      }
      <div style="margin-top: 30px">
        Täytä ladatusta pöytäkirjasta seuraavat tiedot:
        <div style="margin-left: 20px; margin-top: 10px">
          <div style="display: flex; flex-direction: row; flex-wrap: wrap">
            <mat-form-field style="max-width: 155px; margin-right: 10px">
              <mat-label>Kokouksen aika</mat-label>
              <input matInput [matDatepicker]="picker" [formField]="lomake.meetingDate" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <div class="time-container">
              <mat-form-field style="width: 30px">
                <input #startHours timeFormat [timeType]="'hours'" class="time-input" maxlength="2" type="text" [formField]="lomake.meetingHours" matInput autocomplete="kirjnpitomekiarki" cdkFocusInitial />
              </mat-form-field>
              <div class="sep-colon">:</div>
              <mat-form-field style="width: 30px">
                <input timeFormat [timeType]="'minutes'" class="time-input" maxlength="2" type="text" [formField]="lomake.meetingMinutes" matInput autocomplete="kirjnpitomekiarki" />
              </mat-form-field>
            </div>
          </div>
          <mat-form-field style="max-width: 350px">
            <mat-label>Yrityksen voitto koskeva yhtiökokouksen päätös</mat-label>
            <textarea type="text" [formField]="lomake.voittoPaatos" matInput data-lpignore="true" class="skip-space-quick-toggle" cdkTextareaAutosize></textarea>
          </mat-form-field>
          <table>
            <tr>
              <td style="height: 65px; vertical-align: middle">
                <mat-checkbox [formField]="lomake.dividendsDistributed">Osinkoja jaetaan</mat-checkbox>
              </td>
              @if (lomake.dividendsDistributed().value()) {
                <td style="height: 65px; vertical-align: middle">
                  <mat-form-field style="width: 180px; margin-left: 30px">
                    <mat-label>Osingot nostettavissa</mat-label>
                    <input matInput [matDatepicker]="picker2" [formField]="lomake.dividendsPayableDate" />
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                  </mat-form-field>
                </td>
              }
            </tr>
          </table>
        </div>
      </div>
      <app-primary-button
        [disabled]="(liitetiedotLuomattaObservable | async) || !(poytakirjaUploadedObservable | async) || (tilinpaatosAllekirjoitettamattaObservable | async) || ((tilintarkastetaanObservable | async) && (tilintarkastusKertomusLataamatta | async))"
        (click)="savePoytakirjaData()"
        actionId="Tallenna pöytäkirja ja tiedot"
        [actionContext]="[kaytossaOlevatArvot()]"
        styles="margin-top: 20px"
        >Tallenna pöytäkirja ja tiedot</app-primary-button
      >
    </div>
  }
</form>

@if (tilintarkastetaanObservable | async) {
  @if (tilintarkastustiedotObservable | async; as tiedot) {
    <h2 class="otsikko" style="margin-top: 30px; margin-bottom: 15px; margin-left: 10px">
      Tilintarkastuskertomus
      <app-icon-button (click)="avaaInfoTeksti('Lataa tilintarkastuskertomus tähän saatuasi sen tilintarkastajalta.')" actionId="Avaa infoteksti: Tilintarkastus" styles="vertical-align: top;">
        <i class="icon ion-ios-information-circle-outline" style="font-size: 28px; color: gray" aria-hidden="true"></i>
      </app-icon-button>
    </h2>
    @if (kirjanpitajaOnDevaajaObservable | async) {
      <div style="padding-bottom: 20px; padding-left: 20px">
        <h4 style="margin: 0">Urit</h4>
        <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
          Tilintarkastus: käyttäjän tallentamat tiedot: <a [href]="tilintarkastustiedotEncodedUriObservable | async" target="_BLANK">{{ tilintarkastustiedotUriObservable | async }}</a>
        </div>
      </div>
    }
    @if (tilinpaatosAllekirjoitettamattaObservable | async) {
      <div style="margin: 20px" class="error-text">Tilinpäätös on allekirjoitettava Lemonaidissa tai ladattava ennen kertomusta.</div>
    }
    <div style="padding: 0 20px">
      @if (tiedot.kertomus) {
        <table>
          <thead>
            <tr>
              <th>Tiedosto</th>
              <th>Lataa</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ tiedot.kertomus.nimi }}</td>
              <td>
                <app-button (click)="downloadFile(tiedot.kertomus)" actionId="Lataa tilintarkastuskertomus koneelle" additionalClass="lataa-pdf-button">
                  <i class="fa fa-file-pdf-o"></i>
                </app-button>
              </td>
            </tr>
          </tbody>
        </table>
      }
      @if (!tiedot.kertomus) {
        <app-secondary-button (click)="lisaaTilintarkastuskertomus()" [disabled]="tilinpaatosAllekirjoitettamattaObservable | async" actionId="Valitse tiedosto: Lisää tilintarkastuskertomus">
          {{ tiedot.kertomus ? 'Päivitä tilintarkastuskertomus' : '+ Lisää tilintarkastuskertomus' }}
        </app-secondary-button>
      }
    </div>
  } @else {
    <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
  }
}

@if (veroilmoitusNotificationObservable | async; as veroilmoitusNotification) {
  <div style="padding: 15px; font-weight: bold">
    @if (veroilmoitusNotification === 'has-not-been-reported-lemonator-added-resend') {
      <div><i class="fa fa-exclamation-triangle" style="color: #ce6a33; font-size: 1.5em"></i> Lemonator on täyttänyt osingonjakotiedot yhtiökokouksen pöytäkirjalta veroilmoitukselle. Tarkista veroilmoitus ja lähetä se uudelleen.</div>
    }
    @if (veroilmoitusNotification === 'has-been-reported-poytakirja-says-not-check-correctness') {
      <div><i class="fa fa-exclamation-triangle" style="color: #ce6a33; font-size: 1.5em"></i> Lemonator havaitsi, että veroilmoituksella on ilmoitettu jaettuja osinkoja, mutta yhtiökokouksen pöytäkirjan mukaan osinkoja ei jaeta. Tarkista veroilmoitus ja lähetä se tarvittaessa korjattuna uudelleen.</div>
    }
    @if (veroilmoitusNotification === 'has-been-reported-poytakirja-says-yes-check-correctness') {
      <div><i class="fa fa-exclamation-triangle" style="color: #ce6a33; font-size: 1.5em"></i> Lemonator havaitsi, että veroilmoituksella on ilmoitettu jaettuja osinkoja. Tarkista, että määrä ja päiväys täsmäävät yhtiökokouksen pöytäkirjan kanssa. Lähetä veroilmoitus tarvittaessa korjattuna uudelleen.</div>
    }
    <!-- has-not-been-reported-lemonator-did-not-add-noop -->
  </div>
}

<div *ngif="!(rekisteroityObservable | async)" style="margin-top: 60px">&nbsp;</div>

@if (tilinpaatosAllekirjoitettamattaObservable | async) {
  <div style="font-style: italic; margin: 20px; text-align: center">Tilinpäätöstä ei ole vielä allekirjoitettu</div>
}
@if ((tilintarkastetaanObservable | async) && (tilintarkastusKertomusLataamatta | async)) {
  <div style="font-style: italic; margin: 20px; text-align: center">Tilintarkastuskertomusta ei ole vielä ladattu</div>
}
@if (yhtionkokouksenPoytakirjaAllekirjoitettamattaObservable | async) {
  <div style="font-style: italic; margin: 20px; text-align: center">Yhtiökokouksen pöytäkirjaa ei ole vielä allekirjoitettu</div>
}
@if (!(sendDisabledObservable | async) && !(rekisteroityObservable | async)) {
  <div style="text-align: center">Lähetä tilinpäätös rekisteröitäväksi PRH:lle. Lähettämistä ei voi perua.</div>
}
@if (errorTextSubject | async; as errorText) {
  <div class="error-text" style="text-align: center">{{ errorText }}</div>
}

@if (rekisteroityObservable | async; as rekisteroityBy) {
  <div style="padding: 60px 0">
    <div style="text-align: center">{{ rekisteroityBy }}</div>
  </div>
} @else {
  <div style="text-align: center; padding: 30px 20px">
    <app-secondary-button [disabled]="sendDisabledObservable | async" (click)="tallenna('kasin')" actionId="Merkitse tilinpäätös käsin rekisteröidyksi" [actionContext]="[kaytossaOlevatArvot()]">Merkitse käsin rekisteröidyksi</app-secondary-button>
  </div>
  <div style="text-align: center; padding: 0 20px">
    <app-primary-button [disabled]="sendDisabledObservable | async" (click)="tallenna('lemonatorista')" actionId="Lähetä tilinpäätös rekisteröitäväksi" [actionContext]="[kaytossaOlevatArvot()]">Lähetä</app-primary-button>
  </div>
}

<input style="visibility: hidden; height: 1px; position: absolute; left: -9999px" (change)="tpFileChanged($event)" type="file" accept="application/pdf" #fileInputTilinpaatos />
<input style="visibility: hidden; height: 1px; position: absolute; left: -9999px" (change)="pkFileChanged($event)" type="file" accept="application/pdf" #fileInputPoytakirja />
<input style="visibility: hidden; height: 1px; position: absolute; left: -9999px" (change)="kertomusFileChanged($event)" type="file" accept="application/pdf" #fileInputKertomus />
